import collect from 'collect.js';

export const WebviewBridgeCommands = {
  SaveAuthToken: 'SAVE_WEB_APP_AUTH_TOKEN',
  SaveLanguage: 'SAVE_LANGUAGE',
  PlaySound: 'PLAY_SOUND',
  PlayScheduledOrderReminderSound: 'PLAY_SCHEDULE_ORDER_REMINDER_SOUND',
  PrintOrder: 'PRINT_ORDER',
  PrintOrderExternal: 'PRINT_ORDER_EXTERNAL',
  ConnectPrinter: 'CONNECT_PRINTER',
  Navigate: 'NAVIGATE',
};

export default class WebViewCommunicatorResource {
  static sendMessage(data) {
    try {
      window.ReactNativeWebView.postMessage(collect(data)?.toJson());
    } catch (error) {
      window.ReactNativeWebView && console.error('Failed to send message via webview communicator', error);
    }
  }

  static forwardAuthToken(data) {
    this.sendMessage({
      type: WebviewBridgeCommands.SaveAuthToken,
      payload: data,
    });
  }

  static forwardLanguage(data) {
    this.sendMessage({
      type: WebviewBridgeCommands.SaveLanguage,
      payload: data,
    });
  }

  static playSound(type = WebviewBridgeCommands.PlaySound) {
    this.sendMessage({
      type,
      payload: null,
    });
  }

  static printOrder(data) {
    this.sendMessage({
      type: WebviewBridgeCommands.PrintOrder,
      payload: data,
    });
  }

  static printOrderExternal(data) {
    this.sendMessage({
      type: WebviewBridgeCommands.PrintOrderExternal,
      payload: data,
    });
  }

  static connectPrinter(data) {
    this.sendMessage({
      type: WebviewBridgeCommands.ConnectPrinter,
      payload: data,
    });
  }

  static navigate(data) {
    this.sendMessage({
      type: WebviewBridgeCommands.Navigate,
      payload: data,
    });
  }
}
